<template>

    <FlashNotifications ref="flash" />
    
    <button class="bg-blue-600 px-4 py-3 rounded-lg" @click="fetchEvents">Fetch Events</button>
        
    <div class="flex justify-between px-2 py-5 inline-block border-b-2 border-gray-200 dark:border-gray-500">
    
    <div class="flex">             
        <img v-if="orgStoreObj().current_org.profile_picture_url !== ''" alt="profile picture" title="profile picture" class="w-11 h-11 border rounded-full p-0.5"
                    :src="orgStoreObj().current_org.profile_picture_url">
        
        <p v-else :class="orgStoreObj().current_org.avatar_color" class="text-white w-10 h-10 flex justify-center items-center rounded-full">
          {{ orgStoreObj().current_org.avatar_name }}
        </p>
    
        <div class="sm:ml-2 text-xs">
            <p class="pt-1 px-2 mb-1 dark:text-gray-300">{{ orgStoreObj().current_org.name }}</p>
            <p class="flex">
              <span class="max-w-[220px] sm:max-w-[270px] md:max-w-[330px] flex">
                <a :href="'/organizations/' + orgStoreObj().current_org.url + '/dashboard'" target="_blank" class="px-2 text-blue-500 dark:text-gray-400 truncate">{{ APPLICATION_DOMAIN }}/organizations/{{ orgStoreObj().current_org.url }}</a>
              </span>
              <copy-text :text="APPLICATION_DOMAIN + '/organizations/' + orgStoreObj().current_org.url + '/dashboard'"></copy-text>
            </p>
        </div>
    </div>
    
    <div class="flex inline-block">
        <div class="pt-[6px]"> 
            <button id="dropdownExportButton" data-dropdown-toggle="dropdownExport" data-dropdown-placement="bottom-end" type="button" class="w-9 h-9 flex items-center justify-center rounded hover:bg-gray-200 focus:bg-gray-300 dark:hover:bg-gray-600 dark:focus:bg-gray-600">
              <svg class="w-6 h-6 fill-zinc-600 dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"/></svg>
            </button>
        </div>
        
        <div class="ml-1 pt-[6px]">
        <button id="dropdownDelayButton" data-dropdown-toggle="dropdownDelay" data-tooltip-placement="bottom" data-tooltip-target="tooltip-setting" data-dropdown-placement="bottom-end" type="button" class="w-9 h-9 flex items-center justify-center rounded hover:bg-gray-200 focus:bg-gray-300 dark:hover:bg-gray-600 dark:focus:bg-gray-600">
          <svg class="w-[22px] h-[22px] fill-zinc-700 dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z"></path>
            <path d="m2.845 16.136 1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 0 0 9 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 0 0 1.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 0 0-.731-2.732l-.505-.292a7.718 7.718 0 0 0 0-2.224l.505-.292a2.002 2.002 0 0 0 .731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0 0 15 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 0 0-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 0 0 .731 2.732l.505.292a7.683 7.683 0 0 0 0 2.223l-.505.292a2.003 2.003 0 0 0-.731 2.733zm3.326-2.758A5.703 5.703 0 0 1 6 12c0-.462.058-.926.17-1.378a.999.999 0 0 0-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 0 0 1.188-.142 6.071 6.071 0 0 1 2.384-1.399A1 1 0 0 0 11 5.3V4h2v1.3a1 1 0 0 0 .708.956 6.083 6.083 0 0 1 2.384 1.399.999.999 0 0 0 1.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 0 0-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 0 0 .471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 0 0-1.188.142 6.071 6.071 0 0 1-2.384 1.399A1 1 0 0 0 13 18.7l.002 1.3H11v-1.3a1 1 0 0 0-.708-.956 6.083 6.083 0 0 1-2.384-1.399.992.992 0 0 0-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 0 0 .471-1.108z"></path>
          </svg>
        </button>
        </div>
        
        <div class="mx-2 pt-2 hidden md:block">
            <a href="/events/new" type="button" class="text-blue-600 border border-blue-600 hover:bg-gray-100 focus:outline-none rounded text-sm px-4 py-1 text-center mr-2 mb-2 w-full dark:hover:bg-gray-600 dark:text-gray-400 dark:border-gray-500">
              + {{ I18N.application.events.new_event }}
            </a>
        </div>
        
        <div id="dropdownDelay" class="z-10 hidden bg-white border border-gray-300 shadow divide-y divide-gray-100 rounded shadow w-44 dark:bg-[#1C2128] dark:text-gray-200 dark:border-gray-500">
            <ul class="py-2 text-sm text-gray-700 dark:text-gray-400" aria-labelledby="dropdownDelayButton">
              <li>
              </li>
            </ul>
        </div>
        
        <div id="dropdownExport" class="z-10 hidden bg-white border border-gray-300 shadow divide-y divide-gray-100 rounded shadow w-44 dark:bg-[#1C2128] dark:text-gray-200">
            <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDelayButton">
              <li>
                <a href="/exports/events.csv" class="flex items-center px-4 py-2 hover:bg-blue-50 dark:hover:bg-gray-600 dark:hover:text-white">{{ I18N.application.events.export_events }} (csv)</a>
              </li>
            </ul>
          </div>
        </div>
    </div>
    
    <div>
        <div v-if="eventsList.length === 0" class="flex flex-col py-12 items-center justify-center w-full ">
            <div class="flex justify-center items-center w-full">
              <svg class="justify-center items-center" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="120px" height="120px" viewBox="0 0 150 150" version="1.1">
                <defs>
                  <rect id="path-1" x="0" y="0" width="150" height="150"/>
                  <polygon id="path-3" points="0.00048 0 48 0 48 47.99988 0.00048 47.99988"/>
                </defs>
                <g id="Zero_Events_@2x" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Group-42">
                    <mask id="mask-2" fill="white">
                      <use xlink:href="#path-1"/>
                    </mask>
                    <g id="Mask"/>
                    <g mask="url(#mask-2)">
                      <g transform="translate(1.000000, 13.000000)">
                        <path d="M115.20048,123.99988 L4.80048,123.99988 C2.14968,123.99988 0.00048,121.85068 0.00048,119.19988 L0.00048,32.79988 C0.00048,30.14908 2.14968,27.99988 4.80048,27.99988 L115.20048,27.99988 C117.85128,27.99988 120.00048,30.14908 120.00048,32.79988 L120.00048,119.19988 C120.00048,121.85068 117.85128,123.99988 115.20048,123.99988" id="Fill-1" stroke="none" fill="#ECECEE" fill-rule="evenodd"/>
                        <path d="M122.80048,116.39988 L12.40048,116.39988 C9.74968,116.39988 7.60048,114.25068 7.60048,111.59988 L7.60048,25.19988 C7.60048,22.54908 9.74968,20.39988 12.40048,20.39988 L122.80048,20.39988 C125.45128,20.39988 127.60048,22.54908 127.60048,25.19988 L127.60048,111.59988 C127.60048,114.25068 125.45128,116.39988 122.80048,116.39988" id="Fill-3" stroke="none" fill="#FFFFFF" fill-rule="evenodd"/>
                        <g id="Group-8" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(30.400000, 44.400000)">
                          <path d="M1.19988,-0.00012 L1.19988,71.99988" id="Fill-5" fill="#FFFFFF"/>
                          <path d="M1.19988,-0.00012 L1.19988,71.99988" id="Stroke-7" stroke="#DADADA" stroke-width="2"/>
                        </g>
                        <g id="Group-12" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(54.400000, 44.400000)">
                          <path d="M1.20048,-0.00012 L1.20048,71.99988" id="Fill-9" fill="#FFFFFF"/>
                          <path d="M1.20048,-0.00012 L1.20048,71.99988" id="Stroke-11" stroke="#DADADA" stroke-width="2"/>
                        </g>
                        <g id="Group-16" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(78.400000, 44.400000)">
                          <path d="M1.20048,-0.00012 L1.20048,71.99988" id="Fill-13" fill="#FFFFFF"/>
                          <path d="M1.20048,-0.00012 L1.20048,71.99988" id="Stroke-15" stroke="#DADADA" stroke-width="2"/>
                        </g>
                        <g id="Group-20" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(102.400000, 44.400000)">
                          <path d="M1.20048,-0.00012 L1.20048,71.99988" id="Fill-17" fill="#FFFFFF"/>
                          <path d="M1.20048,-0.00012 L1.20048,71.99988" id="Stroke-19" stroke="#DADADA" stroke-width="2"/>
                        </g>
                        <g id="Group-24" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(7.600000, 67.200000)">
                          <path d="M-0.00012,1.19988 L119.99988,1.19988" id="Fill-21" fill="#FFFFFF"/>
                          <path d="M-0.00012,1.19988 L119.99988,1.19988" id="Stroke-23" stroke="#DADADA" stroke-width="2"/>
                        </g>
                        <g id="Group-28" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(7.600000, 91.200000)">
                          <path d="M-0.00012,1.19988 L119.99988,1.19988" id="Fill-25" fill="#FFFFFF"/>
                          <path d="M-0.00012,1.19988 L119.99988,1.19988" id="Stroke-27" stroke="#DADADA" stroke-width="2"/>
                        </g>
                        <path d="M127.60048,44.39988 L7.60048,44.39988 L7.60048,25.19988 C7.60048,22.54908 9.74968,20.39988 12.40048,20.39988 L122.80048,20.39988 C125.45128,20.39988 127.60048,22.54908 127.60048,25.19988 L127.60048,44.39988 Z" id="Fill-29" stroke="none" fill="#DADADA" fill-rule="evenodd"/>
                        <path d="M127.60048,44.39988 L7.60048,44.39988 L7.60048,25.19988 C7.60048,22.54908 9.74968,20.39988 12.40048,20.39988 L122.80048,20.39988 C125.45128,20.39988 127.60048,22.54908 127.60048,25.19988 L127.60048,44.39988 Z" id="Stroke-31" stroke="#939393" stroke-width="3" fill="none"/>
                        <path d="M96.71104,20.39928 C95.73424,23.01408 95.20024,25.84488 95.20024,28.79928 C95.20024,42.05448 105.94504,52.79928 119.20024,52.79928 C122.11384,52.79928 124.90744,52.28088 127.49104,51.32928 L127.49104,20.39928 L96.71104,20.39928 Z" id="Fill-33" stroke="none" fill="#ECECEE" fill-rule="evenodd" style="mix-blend-mode: multiply;"/>
                        <path d="M122.80048,116.39988 L12.40048,116.39988 C9.74968,116.39988 7.60048,114.25068 7.60048,111.59988 L7.60048,25.19988 C7.60048,22.54908 9.74968,20.39988 12.40048,20.39988 L122.80048,20.39988 C125.45128,20.39988 127.60048,22.54908 127.60048,25.19988 L127.60048,111.59988 C127.60048,114.25068 125.45128,116.39988 122.80048,116.39988 Z" id="Stroke-35" stroke="#939393" stroke-width="3" fill="none"/>
                        <g id="Group-39" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(100.000000, 0.000000)">
                          <mask id="mask-4" fill="white">
                            <use xlink:href="#path-3"/>
                          </mask>
                          <g id="Clip-38"/>
                          <path d="M48.00048,23.99988 C48.00048,37.25508 37.25448,47.99988 24.00048,47.99988 C10.74528,47.99988 0.00048,37.25508 0.00048,23.99988 C0.00048,10.74588 10.74528,-0.00012 24.00048,-0.00012 C37.25448,-0.00012 48.00048,10.74588 48.00048,23.99988" id="Fill-37" fill="#939393" mask="url(#mask-4)"/>
                        </g>
                        <path d="M123.9994,17.91144 C121.3246,17.91144 120.3226,20.55864 120.3226,23.98584 C120.3226,27.41304 121.3246,30.08904 123.9994,30.08904 C126.6466,30.08904 127.6498,27.41304 127.6498,23.98584 C127.6498,20.55864 126.6466,17.91144 123.9994,17.91144 M123.9994,14.40024 C129.2938,14.40024 131.6914,19.19304 131.6914,23.98584 C131.6914,28.77984 129.2938,33.60024 123.9994,33.60024 C118.6774,33.60024 116.3098,28.77984 116.3098,23.98584 C116.3098,19.19304 118.6774,14.40024 123.9994,14.40024" id="Fill-40" stroke="none" fill="#FFFFFF" fill-rule="evenodd"/>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="flex w-full items-center justify-center">
              <p class="text-lg font-bold text-gray-500 mb-3 dark:text-gray-400">{{ I18N.application.events.no_events_yet }}</p>
            </div>
            <div class="flex w-full items-center justify-center mb-7 text-gray-500 dark:text-gray-400">
              <p> {{ I18N.application.events.no_events_sub_heading }} </p>
            </div>
            <div class="flex w-full items-center justify-center">
          <button type="button" class="text-white w-36 bg-blue-600 hover:bg-blue-800 focus:outline-none font-bold rounded text-sm  h-9 mx-2 text-center" role="tab" aria-controls="eventtypes" aria-selected="false">
            <a href="/events/new">{{ I18N.application.events.create_event }}</a>
          </button>
        </div>
        </div>
        
        <div v-else>            
            <div class="mx-auto mt-0 grid max-w-2xl grid-cols-1 gap-5 md:max-w-none md:grid-cols-2 lg:grid-cols-3">
                <div v-for="event in eventsList" :key="JSON.stringify(event).id + '12323'">
                    <event :event_json="JSON.stringify(event)"></event>
                </div>
            </div>
            
            <event-table :listable_for_events_page="JSON.stringify(eventsList)"></event-table>
        </div>
    </div>

    <div id="tooltip-setting" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-sm font-light text-white transition-opacity duration-300 bg-gray-900 rounded shadow-sm opacity-0 tooltip">
      {{ I18N.application.events.events_page_settings }}
    </div>
    
    <div id="tooltip-export" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-sm font-light text-white transition-opacity duration-300 bg-gray-900 rounded shadow-sm opacity-0 tooltip">
      {{ I18N.application.events.export_events }}
    </div>
    
    <div id="tooltip-box" role="tooltip" class="absolute z-50 invisible inline-block px-2 py-1 text-sm font-light text-white transition-opacity duration-300 bg-gray-900 rounded shadow-sm opacity-0 tooltip">
      {{ I18N.application.events.event_settings }}
    </div>
  
</template>

<script>
import { orgStore } from "controllers/vue_components/organizations/store"
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"
import FlashNotifications from "controllers/vue_components/flash_toast"

export default {
    name: 'EventsList',
    props: [],
    mixins: [Constants, RequestMixin],
    components: {
        FlashNotifications,
    },
    data() {
        return {
            eventsList: [],
        };
    },
    methods: {
        orgStoreObj() {
            return orgStore();
        },

        async fetchEvents() {
            const response = await this.axiosRequest('GET',`/api/v1/organizations/${this.orgStoreObj().current_org.id}/events`, {}, false)
            this.eventsList = response.response.data;
        }
    },
    computed: { },
    watch: { },
    created() {
        this.fetchEvents();
    }
};
</script>
